module.exports = __webpack_public_path__ + "img/general_catalogue.a8ce78b.png";